// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareFilledSvg from "@fishx/icons-svg/es/asn/UpSquareFilled";
import FishxIcon from '../components/FishxIcon';

var UpSquareFilled = function UpSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareFilledSvg
  }));
};

UpSquareFilled.displayName = 'UpSquareFilled';
export default React.forwardRef(UpSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpSquareFilled.js
// module id = 4328
// module chunks = 0